import InputMask, { ReactInputMask } from 'react-input-mask';

function ZipCodeMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask="99999-999" {...props} />;
}

export default ZipCodeMask;
